import React from 'react';

export const Button = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'primary', 
  size = 'md',
  className = '',
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200';
  
  const variants = {
    primary: disabled 
      ? 'bg-indigo-400 cursor-not-allowed text-white'
      : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md hover:shadow-lg',
    secondary: disabled
      ? 'bg-slate-100 cursor-not-allowed text-slate-400'
      : 'bg-slate-100 hover:bg-slate-200 text-slate-700',
    danger: disabled
      ? 'bg-red-400 cursor-not-allowed text-white'
      : 'bg-red-600 hover:bg-red-700 text-white',
    outline: disabled
      ? 'border border-gray-300 bg-white text-gray-400 cursor-not-allowed'
      : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
    'header-outline': disabled
      ? 'border border-white/30 bg-transparent text-white/50 cursor-not-allowed'
      : 'border border-white/30 bg-transparent text-white hover:bg-white/10 hover:border-white/40'
  };
  
  const sizes = {
    sm: 'px-2.5 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const Input = ({ 
  label, 
  error, 
  helpText,
  className = '',
  ...props 
}) => {
  return (
    <div className="mb-3">
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
        </label>
      )}
      <input
        className={`w-full rounded-lg border border-slate-300 px-3 py-2 text-slate-800 placeholder-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 text-sm transition-all duration-200 ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {helpText && !error && (
        <p className="mt-1 text-sm text-slate-500">{helpText}</p>
      )}
    </div>
  );
};

export const Textarea = ({ 
  label, 
  error, 
  helpText,
  className = '',
  ...props 
}) => {
  return (
    <div className="mb-3">
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
        </label>
      )}
      <textarea
        className={`w-full rounded-lg border border-slate-300 px-3 py-2 text-slate-800 placeholder-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 min-h-16 text-sm transition-all duration-200 ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {helpText && !error && (
        <p className="mt-1 text-sm text-slate-500">{helpText}</p>
      )}
    </div>
  );
};

export const Card = ({ title, subtitle, children, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden ${className}`}>
      {(title || subtitle) && (
        <div className="px-4 py-3 border-b border-slate-200 bg-slate-50">
          {title && <h2 className="text-base font-semibold text-slate-800">{title}</h2>}
          {subtitle && <p className="text-slate-500 text-xs">{subtitle}</p>}
        </div>
      )}
      <div className="p-4">
        {children}
      </div>
    </div>
  );
};

export { LanguageSwitcher } from './LanguageSwitcher.jsx';